<template>
  <div>
    <data-table-card item-add-route-name="administration-supplier-add"
                     item-route-name="administration-supplier"
                     sort-by="companyName"
                     v-bind:filter="filter"
                     v-bind:headers="headers"
                     v-bind:items="items"
                     v-bind:title="$t('suppliers')">
      <template v-slot:item.companyName="{ item }">
        <span class="font-weight-medium">{{ item.companyName | defaultValue($t('untitled')) }}</span>
      </template>
      <template v-slot:item.state="{ item }">
        <state-chip v-bind:state="item.state" />
      </template>
      <template v-slot:item.hasDesign="{ item }">
        <v-icon color="success"
                small
                v-bind:title="$t('designAvailable')"
                v-if="item.hasDesign">ti-palette</v-icon>
        <span class="sf-muted"
              v-else>–</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="sf-row-actions">
          <v-btn icon
                 small
                 v-bind:title="$t('sendEmail')"
                 v-on:click.stop="sendEmailMessage(item.id)">
            <v-icon small>ti-mail-forward</v-icon>
          </v-btn>
        </div>
      </template>
    </data-table-card>
  </div>
</template>

<script>
  import DataTableCard from '@/components/common/DataTableCard'
  import StateChip from '@/components/administration/StateChip'

  export default {
    components: {
      DataTableCard,
      StateChip
    },
    computed: {
      headers() {
        return [
          { text: this.$t('supplierNumber'), value: 'id', width: 130 },
          { text: this.$t('companyName'), value: 'companyName' },
          { text: this.$t('friendlyName'), value: 'supplierGroup' },
          { text: this.$t('boothNumber'), value: 'boothNumber', width: 100 },
          { text: this.$t('location'), value: 'location' },
          { text: this.$t('state'), value: 'state', width: 140 },
          { text: this.$t('design'), value: 'hasDesign', align: 'center', width: 100 },
          { text: '', value: 'actions', align: 'end', sortable: false, filterable: false, width: 70 }
        ]
      },
      filter() {
        return {
          property: 'state',
          values: [
            {
              name: 'all',
              showAll: true,
              title: this.$t('all')
            },
            {
              icon: 'ti-clock',
              name: 'open',
              title: this.$t('open')
            },
            {
              icon: 'ti-mail-check',
              name: 'invited',
              title: this.$t('invited')
            },
            {
              icon: 'ti-check',
              name: 'accepted',
              title: this.$t('accepted')
            },
            {
              icon: 'ti-x',
              name: 'declined',
              title: this.$t('declined')
            }
          ]
        }
      },
      items() {
        return [...this.suppliers].map(s => ({
          ...s,
          hasDesign: s.backgroundId != null || s.logoId != null || s.description != null,
          location: [ s.postalCode, s.city ].filter(v => v != null && v !== '').join(' ')
        }))
      }
    },
    methods: {
      sendEmailMessage(id) {
        this.$emit('send-email-message', { id })
      }
    },
    name: 'SupplierList',
    props: {
      suppliers: Array
    }
  }
</script>

<style scoped>
  .sf-row-actions {
    display: inline-flex;
    gap: 4px;
    white-space: nowrap;
  }
</style>

<i18n>
  {
    "de": {
      "accepted": "Akzeptiert",
      "all": "Alle",
      "boothNumber": "Stand",
      "companyName": "Firma",
      "declined": "Abgelehnt",
      "design": "Design",
      "designAvailable": "Design vorhanden",
      "friendlyName": "Anzeigename",
      "invited": "Eingeladen",
      "location": "Ort",
      "open": "Offen",
      "sendEmail": "E-Mail senden",
      "state": "Status",
      "supplierNumber": "Lieferantennr.",
      "suppliers": "Lieferanten",
      "untitled": "Unbenannt"
    },
    "en": {
      "accepted": "Accepted",
      "all": "All",
      "boothNumber": "Booth",
      "companyName": "Company",
      "declined": "Declined",
      "design": "Design",
      "designAvailable": "Design available",
      "friendlyName": "Display name",
      "invited": "Invited",
      "location": "Location",
      "open": "Open",
      "sendEmail": "Send email",
      "state": "State",
      "supplierNumber": "Supplier no.",
      "suppliers": "Suppliers",
      "untitled": "Untitled"
    }
  }
</i18n>
